<span (click)="onSorting()" class="ps-1">
  <i *ngIf="showAscOrder" class="fas fa-duotone fa-sort-up"></i>
  <i *ngIf="showDescOrder" class="fas fa-duotone fa-sort-down"></i>
  <i *ngIf="showNoOrder" class="fa-sharp fa-solid fa-sort"></i>
</span>
